if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([datas-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[datas-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;

        const index = activeMedia.getAttribute('data-index');
// Select the slick-slider element
const slickSlider = document.querySelector('.slick-slider');


        console.log(index);
// Assuming the slick() method is initialized, you can call it like this if using a library that provides it
if (slickSlider && typeof $(slickSlider).slick === 'function') {
    $(slickSlider).slick('slickGoTo', index);
}

// Prevent vertical scroll behavior from jumping to the last thumbnail
// Adjust `slick-track` translation

// Get the height of a single slide
const slideHeight = slickSlider.querySelector('.slick-slide').offsetHeight;

// Get the slick-track element
const sliderTrack = slickSlider.querySelector('.slick-track');

// Calculate translateY based on clicked index
const translateY = -(index * slideHeight);

// Apply the translation to the slick-track using vanilla JS
sliderTrack.style.transform = `translateY(${translateY}px)`;
        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}